<template>
  <v-container fluid class="pa-0 ma-0">
    <div class="ma-auto" v-if="$vuetify.breakpoint.mdAndDown">
      <v-app-bar fixed app elevate-on-scroll height="50" color="white">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
      </v-app-bar>
    </div>

    <div v-if="$vuetify.breakpoint.mdAndDown" class="pt-12">
      <div class="px-4 pt-14">
        <v-card class="profile-card mb-4 pa-4" elevation="1" rounded="xl">
          <div class="d-flex flex-column align-center">
            <v-avatar size="120" class="profile-avatar mb-3">
              <v-img
                v-if="
                  user.profilePicture &&
                  user.profilePicture !== 'NOT_ASSIGNED' &&
                  user.profilePicture !== 'N/D'
                "
                :src="user.profilePicture"
              ></v-img>
              <v-img
                v-else
                src="https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?b=1&s=170667a&w=0&k=20&c=-qQGlKM8OQsSJCEkHnqS9FI94VRTkZ-7tg0K0u02XL0="
              ></v-img>
            </v-avatar>

            <template v-if="isTitular">
              <div class="profile-name text-center">
                {{ profileDisplayName }}
              </div>
              <div
                v-if="chapterLabel && user.branch"
                class="profile-chapter text-center mt-1"
              >
                {{ chapterLabel }} {{ branchDisplayName }}
              </div>
            </template>

            <template v-else>
              <div class="profile-name text-center">
                {{ user.name }} {{ user.firstLastname }}
              </div>
            <v-chip
              color="#f87623"
              class="white--text font-weight-bold mt-2"
              small
            >
              Submiembro/Colaborador
            </v-chip>
            </template>
          </div>
        </v-card>
      </div>
      <PortalSession v-if="isActiveBilling"></PortalSession>
    </div>

    <v-row class="d-flex">
      <v-col
        class="mx-16 px-16"
        :cols="$vuetify.breakpoint.mdAndDown ? '0' : '1'"
      >
        <v-navigation-drawer
          floating
          app
          class="sidebar-drawer"
          v-model="drawer"
        >
          <div class="sidebar-items-wrapper">
            <div class="sidebar-item-wrapper">
              <v-card
                class="profile-card mx-3 mt-3"
                elevation="1"
                rounded="xl"
              >
                <div class="d-flex flex-column align-center pa-4">
                  <v-avatar size="120" class="profile-avatar mb-3">
                    <v-img
                      v-if="
                        user.profilePicture &&
                        user.profilePicture !== 'NOT_ASSIGNED' &&
                        user.profilePicture !== 'N/D'
                      "
                      :src="user.profilePicture"
                    ></v-img>
                    <v-img
                      v-else
                      src="https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?b=1&s=170667a&w=0&k=20&c=-qQGlKM8OQsSJCEkHnqS9FI94VRTkZ-7tg0K0u02XL0="
                    ></v-img>
                  </v-avatar>

                  <template v-if="isTitular">
                    <div class="profile-name text-center">
                      {{ profileDisplayName }}
                    </div>
                    <div
                      v-if="chapterLabel && user.branch"
                      class="profile-chapter text-center mt-1"
                    >
                      {{ chapterLabel }} {{ branchDisplayName }}
                    </div>
                  </template>

                  <template v-else>
                    <div class="profile-name text-center">
                      {{ user.name }} {{ user.firstLastname }}
                    </div>
                    <v-chip
                      color="#f87623"
                      class="white--text font-weight-bold mt-2"
                      small
                    >
                      Submiembro/Colaborador
                    </v-chip>
                  </template>
                </div>
              </v-card>
            </div>

            <div class="sidebar-item-wrapper">
              <v-card
                class="menu-card mx-3 mb-3"
                elevation="1"
                rounded="xl"
              >
                <v-list
                  nav
                  rounded
                  class="buton-link pa-2"
                >
                  <v-list-item-group v-model="selectedItem" class="align-center">
                    <v-list-item
                      v-for="(it, i) in items"
                      dense
                      :key="i"
                      :to="it.external ? undefined : it.route"
                      :href="it.route"
                      :target="it.external ? '_blank' : '_self'"
                      active-class="white--text wDarkerBlue"
                      :disabled="it.disabled"
                      class="px-2 my-0"
                    >
                      <v-list-item-icon class="mx-3">
                        <v-icon>{{ it.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content class="px-2 py-0">
                        <v-list-item-title>{{ it.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

                <v-divider class="my-2"></v-divider>

                <div class="px-3 pb-3">
                  <v-list-item class="justify-center pa-0">
                    <v-btn
                      elevation="1"
                      depressed
                      text
                      @click="_logout()"
                      class="font-weight-bold rounded-pill"
                    >
                      Cerrar sesión
                    </v-btn>
                  </v-list-item>
                  <v-list-item
                    class="justify-center pa-0"
                    v-if="
                      user.role == 'MEMBER' &&
                      user.headOffice &&
                      ['62b622c66a7441ae20159d7d', '6297b0fec7bf8b6f826313be'].includes(
                        typeof user.headOffice === 'object'
                          ? user.headOffice._id
                          : user.headOffice
                      )
                    "
                  >
                    <v-btn
                      elevation="0"
                      color="#35404c"
                      @click="_goToProfiles()"
                      class="font-weight-bold rounded-pill white--text"
                    >
                      Cambiar perfil
                    </v-btn>
                  </v-list-item>
                  <v-list-item class="px-0 justify-center pa-0">
                    <v-img
                      src="@/assets/images/weChamber/poweredby.svg"
                      max-height="120"
                      max-width="120"
                    ></v-img>
                  </v-list-item>
                </div>
              </v-card>
            </div>
          </div>
        </v-navigation-drawer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import PortalSession from "./PortalSession.vue";
import { isOrganization } from "../../share/validateOrganization";

export default {
  name: "SideBar",
  components: {
    PortalSession,
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      isActiveBilling: false,
      drawer: true,
      selectedItem: 0,
    };
  },
  methods: {
    ...mapMutations("member", ["delItems"]),
    ...mapMutations("membershipProfile", ["removeMembershipProfile"]),
    ...mapActions("user", ["realoadUserData", "logout"]),
    ...mapActions("member", [
      "fetchMemberCredentials",
      "deleteMemberItems",
    ]),
    ...mapActions("membershipUsers", ["fetchMembershipCredentials"]),
    isOrganization,
    async getBillingConfig() {
      try {
        const response = await this.axios({
          method: "GET",
          url: "/billing/config",
        });
        this.isActiveBilling = response.data.billingConfig.isActive;
      } catch (error) {
        this.showErrorDialog = true;
      }
    },
    async reloadMemberInfo() {
      await this.realoadUserData({ email: this.user.email });
    },
    async _logout() {
      await this.deleteMemberItems();
      await this.removeMembershipProfile();
      await this.logout();
    },
    _goToProfiles() {
      this.delItems();
      this.removeMembershipProfile();
      this.$router.push("/member/affiliation-profile");
    },
  },
  computed: {
    ...mapState("member", ["credential"]),
    ...mapState("membershipUsers", ["credential"]),
    ...mapState("user", ["user"]),

    isTitular() {
      return this.user && this.user.role === "MEMBER";
    },

    isCompanyOrganization() {
      return this.user?.headOffice?.memberType === "COMPANYS";
    },

    profileDisplayName() {
      if (this.isCompanyOrganization) {
        return this.user?.company || "N/D";
      }
      const fullName = [this.user?.name, this.user?.firstLastname]
        .filter(Boolean)
        .join(" ")
        .trim();
      return fullName || "N/D";
    },

    isSubmember() {
      return this.user && this.user.role === "MEMBERSHIP_USER";
    },

    isAsofom() {
      const headOfficeId = this.headOfficeId;
      return isOrganization("asofom", null, headOfficeId);
    },

    headOfficeId() {
      if (!this.user || !this.user.headOffice) return null;
      return typeof this.user.headOffice === "object"
        ? this.user.headOffice.id || this.user.headOffice._id
        : this.user.headOffice;
    },

    chapterLabel() {
      if (!this.user || !this.user.branch) return null;
      if (!this.user.branch || this.user.branch === "N/D") return null;
      return this.isAsofom ? "Región:" : "Capítulo:";
    },

    branchDisplayName() {
      if (!this.user || !this.user.branch) return "N/D";
      return typeof this.user.branch === "object"
        ? this.user.branch.company || "N/D"
        : this.user.branch;
    },
  },

  async created() {
    if (this.$vuetify.breakpoint.mdAndDown) {
      this.drawer = false;
    }
    await this.getBillingConfig();
    if (!this.credential.credentialInformation) {
      if (this.user.role == "MEMBER") {
        await this.fetchMemberCredentials();
      } else {
        await this.fetchMembershipCredentials();
      }
    }
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Montserrat-Black";
  src: url("/assets/fonts/Montserrat/MONTSERRAT_Montserrat-Bold.otf")
    format("opentype");
}

.sidebar-drawer,
.sidebar-drawer ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  background-color: transparent !important;
}

.sidebar-drawer {
  border-right: 1px solid #c9ccd1 !important;
}

.sidebar-drawer ::v-deep .v-navigation-drawer__content {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.3s ease;
}

.sidebar-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 6px;
}

.sidebar-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

.sidebar-drawer:hover ::v-deep .v-navigation-drawer__content {
  scrollbar-color: rgba(30, 46, 62, 0.25) transparent;
}

.sidebar-drawer:hover ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: rgba(30, 46, 62, 0.25);
}

.sidebar-drawer:hover ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(30, 46, 62, 0.4);
}

.sidebar-items-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.sidebar-item-wrapper {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.sidebar-item-wrapper + .sidebar-item-wrapper {
  margin-top: 24px;
}

.profile-card {
  background-color: #ffffff !important;
  width: auto;
  box-sizing: border-box;
}

.menu-card {
  background-color: #ffffff !important;
  width: auto;
  box-sizing: border-box;
  overflow: visible;
  border-radius: 24px !important;
}

.profile-avatar {
  background-color: #f0f1f4;
}

.profile-name {
  color: #1e2e3e;
  font-weight: 800;
  font-size: 18px;
  line-height: 1.2;
  word-break: break-word;
}

.profile-chapter {
  color: #5a6677;
  font-weight: 500;
  font-size: 14px;
}
</style>
